(() => {
  function init(root = document) {
    root.querySelectorAll('[data-nervo-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const track = gallery.querySelector('[data-nervo-track]');
      const thumbs = [...gallery.querySelectorAll('[data-nervo-index]')];
      const prev = gallery.querySelector('[data-nervo-prev]');
      const next = gallery.querySelector('[data-nervo-next]');
      const count = gallery.querySelector('[data-nervo-count]');
      let index = 0;
      const go = i => { const target = Math.max(0, Math.min(thumbs.length - 1, i)); track.scrollTo({left: target * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}); };
      const sync = () => { index = Math.round(track.scrollLeft / track.clientWidth); thumbs.forEach((b, i) => b.setAttribute('aria-pressed', String(i === index))); count.textContent = `${index + 1} / ${thumbs.length}`; prev.disabled = index === 0; next.disabled = index === thumbs.length - 1; };
      thumbs.forEach((button, i) => button.addEventListener('click', () => go(i)));
      prev.addEventListener('click', () => go(index - 1)); next.addEventListener('click', () => go(index + 1));
      track.addEventListener('scroll', sync, {passive:true});
      track.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); go(index + (e.key === 'ArrowRight' ? 1 : -1)); } });
      new ResizeObserver(() => { track.scrollLeft = index * track.clientWidth; }).observe(track);
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
